import React from "react";
import { StaticImage } from "gatsby-plugin-image";

// Import styles
import "./styles/intro.scss";

// Import icons
import { FaAngleDown } from "@react-icons/all-files/fa/FaAngleDown";
import { FaRegPlayCircle } from "@react-icons/all-files/fa/FaRegPlayCircle";
import { FaTimes } from "@react-icons/all-files/fa/FaTimes";

// Import lite youtube embed
import { LiteYouTubeEmbed } from "react-lite-youtube-embed";

// Import gatsby anchor links
import { AnchorLink } from "gatsby-plugin-anchor-links";

// Import bootstrap
import { Container, Modal } from "react-bootstrap";

const Intro = (props) => {
  let video = props.data.homepageFields.intro.video;
  let videoUrl = video.replace("https://youtu.be/", "");
  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        className="intro-modal"
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="modal-90w"
        centered
      >
        <div
          className="close"
          onClick={props.onHide}
          onKeyDown={props.onHide}
          role="button"
          tabIndex={0}
        >
          <h2 className="declare">{overlaidText}</h2>
          <FaTimes />
        </div>
        <LiteYouTubeEmbed
          id={videoUrl}
          title="Test video"
          activeClass="lyt-activated" // Default as "lyt-activated", gives control to wrapper once clicked
          iframeClass="" // Default none, gives control to add a class to iframe element itself
          playerClass="lty-playbtn" // Default as "lty-playbtn" to control player button styles
          wrapperClass="yt-lite" // Default as "yt-lite" for the div wrapping the area, it is the most important class and needs extra attention, please refer to LiteYouTubeEmbed.css for a reference.
        />
      </Modal>
    );
  }

  const [modalShow, setModalShow] = React.useState(false);
  let headline = props.data.homepageFields.intro.headline;
  let overlaidText = props.data.homepageFields.intro.overlaidText;
  return (
    <section className="intro">
      <div className="overlay" />
      <StaticImage
        className="image"
        src="../assets/images/mountains.jpg"
        alt="Illustration of a mountain range at sunset."
      />
      <div className="text">
        <Container className="fade-in-slowest">
          <div
            className="play"
            onClick={() => setModalShow(true)}
            onKeyDown={() => setModalShow(true)}
            role="button"
            tabIndex={0}
          >
            <span>Play</span>
            <FaRegPlayCircle />
            <span>Video</span>
          </div>
          <h1 className="shout backgroundText">{headline}</h1>
          <div className="shout overlayText">{overlaidText}</div>
          <AnchorLink
            className="btn btn-link stripped"
            to="/#portfolio"
            title="Check out our portfolio!"
            stripHash
          >
            View Portfolio
            <FaAngleDown />
          </AnchorLink>

          <MyVerticallyCenteredModal
            show={modalShow}
            onHide={() => setModalShow(false)}
          />
        </Container>
      </div>
    </section>
  );
};

export default Intro;
